import type { QueryClient } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export const SITE_AVAILABILITY_EVENT = 'miahma:availability-changed';
export function announceAvailabilityChange() {
  window.dispatchEvent(new Event(SITE_AVAILABILITY_EVENT));
}

/** Only public availability queries; never orders, payments, or financial effects. */
export function isAvailabilityQuery(key: readonly unknown[]) {
  const name = String(key[0]);
  return name.startsWith('site-grid') || name.startsWith('site-achadinhos')
    || ['quick-variants', 'site-video-reels', 'public-looks', 'look-sizes', 'site-video-feed', 'home-videos', 'outlet-vip-unlocked'].includes(name)
    || (name === 'products' && key[1] === 'site');
}
export function invalidateAvailability(client: QueryClient) {
  return client.invalidateQueries({ predicate: q => isAvailabilityQuery(q.queryKey) });
}

/** Read only: reservations already reduce stock_online. No reservation is created here. */
export async function checkCartAddition(sizeVariantId: string | undefined, quantity: number): Promise<number | null> {
  if (!sizeVariantId || !Number.isInteger(quantity) || quantity < 1) throw new Error('invalid_selection');
  const { data, error } = await supabase.rpc('check_stock_availability', {
    p_stock_location: 'online', p_items: [{ sizeVariantId, quantity }],
  }).abortSignal(AbortSignal.timeout(10_000));
  if (error) throw error;
  const result = data as { success?: boolean; unavailable_items?: { sizeVariantId: string; available: number }[] } | null;
  if (result?.success === true) return null;
  const unavailable = result?.unavailable_items?.find(i => i.sizeVariantId === sizeVariantId);
  if (!unavailable || !Number.isInteger(unavailable.available) || unavailable.available < 0) throw new Error('invalid_stock_response');
  return unavailable.available;
}